import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SettingService } from '../../../core/services/setting.service';
import { AuthService } from '../../auth/services/auth.service';
import { Router } from '@angular/router';
import { SETTINGS } from '../../../core/config/common.settings';
import { ChargebeeService } from '../../../core/services/chargebee.service';
import { NzMessageService } from 'ng-zorro-antd/message';

declare var Chargebee: any;
@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {

  brand: any;
  constructor(
    private settingService: SettingService,
    private authService: AuthService,
    private router: Router,
    private message: NzMessageService,
    private chargebeeService: ChargebeeService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    // this.findBrand().then( (r: any) => {
    //   this.brand = r;
    //   this.onClickManage();
    // });
    this.onClickManage();
  }

  // onClickManage(): void {
  //   //portal
  //   Chargebee.init({
  //       site: SETTINGS.CHARGEBEE_SITE,
  //     isItemsModel: true,
  //   });
  //   const cbInstance = Chargebee.getInstance();
  //   const cbPortal = cbInstance.createChargebeePortal();
  //   const {payment} = this.brand;
  //   const baseUrl = window.location.origin;
  //
  //   cbPortal.open({
  //     customerId: payment.customerId,
  //     redirectUrl: `${baseUrl}/admin`,
  //     loaded: () => {
  //       console.log('✅ Portal has loaded.');
  //     },
  //
  //     success: (data: any) => {
  //       console.log('🎉 Portal action successful:');
  //     },
  //
  //     close: () => {
  //       console.log('❎ Portal was closed.');
  //       this.router.navigate(['/admin']);
  //     },
  //   });
  // }

  onClickManage(): void {
    //portal sessions
    Chargebee.init({
      site: SETTINGS.CHARGEBEE_SITE,
      isItemsModel: true,
    });
    const cbInstance = Chargebee.getInstance();
    cbInstance.setPortalSession( () => this.getPortalSession());
    const cbPortal = cbInstance.createChargebeePortal();
    const baseUrl = window.location.origin;

    cbPortal.open({
      redirectUrl: `${baseUrl}/admin`,
      loaded: () => {
        console.log(this.translocoService.translate('chargebee.portal.messages.loaded'));
      },

      success: (data: any) => {
        console.log(this.translocoService.translate('chargebee.portal.messages.success'));
        window.location.href = baseUrl;
      },

      close: () => {
        console.log(this.translocoService.translate('chargebee.portal.messages.closed'));
        window.location.href = baseUrl;
      },
    });
  }

  async findBrand(): Promise<void> {
    try {
      const user = await this.authService.getLoggedInUser();
      this.brand = await this.settingService.findBrand(user.userId);
    } catch (e) {}
  }

  async getPortalSession(): Promise<any> {
    try {
      return await this.chargebeeService.createPortalSession();
    } catch (e: any) {
      this.message.error(
        e?.message ||
        e ||
        this.translocoService.translate('chargebee.portal.messages.sessionError')
      );
    }
  }

}
